/** 扫描支票的 PDF 页面尺寸较小，预览默认适合宽度；保留页码等参数，不修改原件下载地址。 */
export function pdfFitWidthUrl(url) {
  const source = String(url || "");
  const hashAt = source.indexOf("#");
  const base = hashAt < 0 ? source : source.slice(0, hashAt);
  const options = hashAt < 0 ? [] : source.slice(hashAt + 1).split("&").filter(Boolean);
  return `${base}#${[...options.filter(option => !/^(?:view|zoom)=/i.test(option)), "view=FitH"].join("&")}`;
}
